import PropTypes from 'prop-types'

import {
  Dialog,
  DialogContent,
  DialogActions,
  Box,
  Typography,
  Button,
  makeStyles,
} from '@material-ui/core'

import useSnackbar from 'hooks/useSnackbar'

import * as service from 'service'

import styles from './styles'
import helpers from 'helpers'

const useStyles = makeStyles(styles)

const DialogCard = ({
  open,
  setOpen,
  values,
  customer,
  order,
  token,
  type,
  setLoading,
  setDisableButton,
}) => {
  const classes = useStyles()
  const snackbar = useSnackbar()

  const onSubmit = async () => {
    setLoading(true)
    try {
      switch (type) {
        case 'plan':
          await service.intermediador.payments.full({
            order: orderParams(order?.payment, values, customer, token, type),
            seller_auth_token: order?.seller?.token,
          })
          break
        case 'product':
          await service.intermediador.payments.create({
            order: orderParams(order?.payment, values, customer, token, type),
            seller_auth_token: order?.seller?.token,
          })
          break
        default:
          await service.intermediador.payments.pay({
            order: orderParams(order?.payment, values, customer, token, type),
            seller_auth_token: order?.seller?.token,
          })
          break
      }

      setOpen(false)
      setDisableButton(true)

      snackbar.open({
        message: `${`Pagamento feito com sucesso!`}`,
        variant: 'success',
      })

      setLoading(false)
    } catch (error) {
      setOpen(false)
      setDisableButton(false)
      snackbar.open({
        message:
          error?.response?.data?.error?.message ||
          `Ocorreu um erro ao criar ao realizar o pagamento`,
        variant: 'error',
      })
      setLoading(false)
    }
  }

  const orderParams = (order, values, customer, token, type) => {
    const params = {
      orderType: type,
      token: token,
      code: order?.code || generateCode(order, type),
      payment: {
        method: helpers.formatters.getMethodIdByBrand(values.number),
        splitNumber: values.splitNumber,
        card: {
          name: values.name,
          expiration: values.expiry,
          number: values.number.replace(/ /g, ''),
          cvv: values.cvv,
        },
        recurrency: values.recurrency,
      },
      products: formatProducts(order?.products),
      customer: formatCustomer(customer),
    }
    return params
  }

  const generateCode = (order, type) => {
    if (type === 'product') {
      let productToken = order?.products?.[0]?.['productToken']
      let randomNumber = Math.floor(Date.now() * Math.random())
      return `P#${productToken}#${randomNumber}`
    }
  }

  const removeProductsDiscount = (arr) => {
    const newArray = arr.filter((item) => item.name !== 'Desconto')
    return newArray
  }

  const formatProducts = (products) => {
    products?.forEach((prod) => {
      delete prod['startsAt']
      delete prod['endsAt']
      delete prod['type']
    })

    return removeProductsDiscount(products)
  }

  const formatCustomer = (customer) => {
    const formattedCustomer = {
      birthDate: customer.birthDate,
      document: customer.document
        .split('-')
        .join('')
        .split('.')
        .join('')
        .split('/')
        .join(''),
      documentType: customer.documentType,
      email: customer.email,
      name: customer.name,
      address: {
        city: customer.address.city,
        neighborhood: customer.address.neighborhood,
        number: customer.address.number,
        postalCode: customer.address.postalCode.replace('-', ''),
        state: customer.address.state,
        street: customer.address.street,
      },
    }

    return formattedCustomer
  }

  return (
    <Dialog
      className={classes.modal}
      maxWidth="lg"
      open={open}
      onClose={() => setOpen(false)}
    >
      <DialogContent className={classes.modalContent}>
        <Box my={1}>
          <Typography>Você deseja realizar o pagamento via cartão?</Typography>
        </Box>
      </DialogContent>
      <DialogActions p={2}>
        <Box pl={2} pr={1} display="flex" justifyContent="center">
          <Button
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
        </Box>
        <Button
          variant="contained"
          type="submit"
          color="primary"
          onClick={onSubmit}
        >
          Sim
        </Button>
      </DialogActions>
    </Dialog>
  )
}

DialogCard.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  values: PropTypes.object,
}

export default DialogCard
